export const RENDER_ORDERS = 'Render_Orders';
export const RENDER_MAP = 'Render_Map';